/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  InvitationCreatedResponseDto,
  InvitationResponseDto,
  InvitationVerifyResponseDto,
  InvitationsControllerFindAllParams,
  InviteUserDto,
  MessageResponseDto,
  MyInvitationResponseDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Invite a user by email to join the organization (owner only)
 * @summary Send an invitation
 */
export const invitationsControllerCreate = (
  orgId: string,
  inviteUserDto: InviteUserDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<InvitationCreatedResponseDto>(
    {
      url: `/api/organizations/${orgId}/invitations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteUserDto,
      signal,
    },
    options
  );
};

export const getInvitationsControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitationsControllerCreate>>,
    TError,
    { orgId: string; data: InviteUserDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invitationsControllerCreate>>,
  TError,
  { orgId: string; data: InviteUserDto },
  TContext
> => {
  const mutationKey = ['invitationsControllerCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitationsControllerCreate>>,
    { orgId: string; data: InviteUserDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return invitationsControllerCreate(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvitationsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerCreate>>
>;
export type InvitationsControllerCreateMutationBody = InviteUserDto;
export type InvitationsControllerCreateMutationError = void;

/**
 * @summary Send an invitation
 */
export const useInvitationsControllerCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invitationsControllerCreate>>,
      TError,
      { orgId: string; data: InviteUserDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof invitationsControllerCreate>>,
  TError,
  { orgId: string; data: InviteUserDto },
  TContext
> => {
  const mutationOptions = getInvitationsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all invitations for the organization (owner only)
 * @summary List organization invitations
 */
export const invitationsControllerFindAll = (
  orgId: string,
  params?: InvitationsControllerFindAllParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<InvitationResponseDto[]>(
    { url: `/api/organizations/${orgId}/invitations`, method: 'GET', params, signal },
    options
  );
};

export const getInvitationsControllerFindAllQueryKey = (
  orgId?: string,
  params?: InvitationsControllerFindAllParams
) => {
  return [`/api/organizations/${orgId}/invitations`, ...(params ? [params] : [])] as const;
};

export const getInvitationsControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof invitationsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  params?: InvitationsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInvitationsControllerFindAllQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationsControllerFindAll>>> = ({
    signal,
  }) => invitationsControllerFindAll(orgId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof invitationsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InvitationsControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerFindAll>>
>;
export type InvitationsControllerFindAllQueryError = void;

export function useInvitationsControllerFindAll<
  TData = Awaited<ReturnType<typeof invitationsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  params: undefined | InvitationsControllerFindAllParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindAll>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerFindAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvitationsControllerFindAll<
  TData = Awaited<ReturnType<typeof invitationsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  params?: InvitationsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindAll>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerFindAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvitationsControllerFindAll<
  TData = Awaited<ReturnType<typeof invitationsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  params?: InvitationsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List organization invitations
 */

export function useInvitationsControllerFindAll<
  TData = Awaited<ReturnType<typeof invitationsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  params?: InvitationsControllerFindAllParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInvitationsControllerFindAllQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resend an invitation email with a new token and extended expiry (owner only)
 * @summary Resend an invitation
 */
export const invitationsControllerResend = (
  orgId: string,
  invitationId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<InvitationCreatedResponseDto>(
    {
      url: `/api/organizations/${orgId}/invitations/${invitationId}/resend`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getInvitationsControllerResendMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitationsControllerResend>>,
    TError,
    { orgId: string; invitationId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invitationsControllerResend>>,
  TError,
  { orgId: string; invitationId: string },
  TContext
> => {
  const mutationKey = ['invitationsControllerResend'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitationsControllerResend>>,
    { orgId: string; invitationId: string }
  > = (props) => {
    const { orgId, invitationId } = props ?? {};

    return invitationsControllerResend(orgId, invitationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvitationsControllerResendMutationResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerResend>>
>;

export type InvitationsControllerResendMutationError = void;

/**
 * @summary Resend an invitation
 */
export const useInvitationsControllerResend = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invitationsControllerResend>>,
      TError,
      { orgId: string; invitationId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof invitationsControllerResend>>,
  TError,
  { orgId: string; invitationId: string },
  TContext
> => {
  const mutationOptions = getInvitationsControllerResendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revoke a pending invitation (owner only)
 * @summary Revoke an invitation
 */
export const invitationsControllerRevoke = (
  orgId: string,
  invitationId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/organizations/${orgId}/invitations/${invitationId}`, method: 'DELETE' },
    options
  );
};

export const getInvitationsControllerRevokeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitationsControllerRevoke>>,
    TError,
    { orgId: string; invitationId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invitationsControllerRevoke>>,
  TError,
  { orgId: string; invitationId: string },
  TContext
> => {
  const mutationKey = ['invitationsControllerRevoke'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitationsControllerRevoke>>,
    { orgId: string; invitationId: string }
  > = (props) => {
    const { orgId, invitationId } = props ?? {};

    return invitationsControllerRevoke(orgId, invitationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvitationsControllerRevokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerRevoke>>
>;

export type InvitationsControllerRevokeMutationError = void;

/**
 * @summary Revoke an invitation
 */
export const useInvitationsControllerRevoke = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invitationsControllerRevoke>>,
      TError,
      { orgId: string; invitationId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof invitationsControllerRevoke>>,
  TError,
  { orgId: string; invitationId: string },
  TContext
> => {
  const mutationOptions = getInvitationsControllerRevokeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all pending invitations addressed to the current authenticated user
 * @summary List my pending invitations
 */
export const invitationsControllerFindMine = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MyInvitationResponseDto[]>(
    { url: `/api/invitations/me`, method: 'GET', signal },
    options
  );
};

export const getInvitationsControllerFindMineQueryKey = () => {
  return [`/api/invitations/me`] as const;
};

export const getInvitationsControllerFindMineQueryOptions = <
  TData = Awaited<ReturnType<typeof invitationsControllerFindMine>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindMine>>, TError, TData>
  >;
  request?: SecondParameter<typeof authFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInvitationsControllerFindMineQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationsControllerFindMine>>> = ({
    signal,
  }) => invitationsControllerFindMine(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof invitationsControllerFindMine>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InvitationsControllerFindMineQueryResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerFindMine>>
>;
export type InvitationsControllerFindMineQueryError = void;

export function useInvitationsControllerFindMine<
  TData = Awaited<ReturnType<typeof invitationsControllerFindMine>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindMine>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerFindMine>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerFindMine>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvitationsControllerFindMine<
  TData = Awaited<ReturnType<typeof invitationsControllerFindMine>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindMine>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerFindMine>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerFindMine>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvitationsControllerFindMine<
  TData = Awaited<ReturnType<typeof invitationsControllerFindMine>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List my pending invitations
 */

export function useInvitationsControllerFindMine<
  TData = Awaited<ReturnType<typeof invitationsControllerFindMine>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerFindMine>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInvitationsControllerFindMineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Decline an invitation addressed to the current user
 * @summary Decline an invitation
 */
export const invitationsControllerDecline = (
  token: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/invitations/decline/${token}`, method: 'POST', signal },
    options
  );
};

export const getInvitationsControllerDeclineMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitationsControllerDecline>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invitationsControllerDecline>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ['invitationsControllerDecline'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitationsControllerDecline>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return invitationsControllerDecline(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvitationsControllerDeclineMutationResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerDecline>>
>;

export type InvitationsControllerDeclineMutationError = void;

/**
 * @summary Decline an invitation
 */
export const useInvitationsControllerDecline = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invitationsControllerDecline>>,
      TError,
      { token: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof invitationsControllerDecline>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationOptions = getInvitationsControllerDeclineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Verify an invitation token and get invitation details (public endpoint)
 * @summary Verify invitation token
 */
export const invitationsControllerVerify = (
  token: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<InvitationVerifyResponseDto>(
    { url: `/api/invitations/verify/${token}`, method: 'GET', signal },
    options
  );
};

export const getInvitationsControllerVerifyQueryKey = (token?: string) => {
  return [`/api/invitations/verify/${token}`] as const;
};

export const getInvitationsControllerVerifyQueryOptions = <
  TData = Awaited<ReturnType<typeof invitationsControllerVerify>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerVerify>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInvitationsControllerVerifyQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationsControllerVerify>>> = ({
    signal,
  }) => invitationsControllerVerify(token, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!token, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof invitationsControllerVerify>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InvitationsControllerVerifyQueryResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerVerify>>
>;
export type InvitationsControllerVerifyQueryError = void;

export function useInvitationsControllerVerify<
  TData = Awaited<ReturnType<typeof invitationsControllerVerify>>,
  TError = void,
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerVerify>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerVerify>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerVerify>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvitationsControllerVerify<
  TData = Awaited<ReturnType<typeof invitationsControllerVerify>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerVerify>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationsControllerVerify>>,
          TError,
          Awaited<ReturnType<typeof invitationsControllerVerify>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInvitationsControllerVerify<
  TData = Awaited<ReturnType<typeof invitationsControllerVerify>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerVerify>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Verify invitation token
 */

export function useInvitationsControllerVerify<
  TData = Awaited<ReturnType<typeof invitationsControllerVerify>>,
  TError = void,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof invitationsControllerVerify>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInvitationsControllerVerifyQueryOptions(token, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Accept an invitation and join the organization
 * @summary Accept an invitation
 */
export const invitationsControllerAccept = (
  token: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/invitations/accept/${token}`, method: 'POST', signal },
    options
  );
};

export const getInvitationsControllerAcceptMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invitationsControllerAccept>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invitationsControllerAccept>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ['invitationsControllerAccept'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invitationsControllerAccept>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return invitationsControllerAccept(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvitationsControllerAcceptMutationResult = NonNullable<
  Awaited<ReturnType<typeof invitationsControllerAccept>>
>;

export type InvitationsControllerAcceptMutationError = void;

/**
 * @summary Accept an invitation
 */
export const useInvitationsControllerAccept = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invitationsControllerAccept>>,
      TError,
      { token: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof invitationsControllerAccept>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationOptions = getInvitationsControllerAcceptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
